if (typeof Plugin_Common == 'undefined') {

    var Plugin_Common = {

        init: function () {
            Plugin_Common.replaceGridPagers();
            Plugin_Common.highlightOpenedTitles();
            Plugin_Common.modalUploadModifyButton();
        },

        initPracovniciAutocomplete: function () {

            $(document).on('modal.miniform.item.add.build modal.miniform.item.add.error modal.miniform.item.edit.build modal.miniform.item.edit.error', function (e) {
                var modalPanel = $('#modal-panel-pracovnici-ve-smlouve');
                if (!modalPanel.length) {
                    return;
                }

                var jmenoPracovnika = $('#modal-jmenopracovnika');
                if (!jmenoPracovnika.length) {
                    return;
                }

                var _ch = $('#_ch');
                if(!_ch.length) {
                    return;
                }

                var url = window.location.protocol + '//' + window.location.host;
                url += '/plugin/PluginCommon/ajaxVyhledejPracovnika';

                jmenoPracovnika.autocomplete({
                    autofocus: true,
                    minLength: 3,
                    global: false,
                    source: function (request, response) {
                        $.ajax({
                            url: url,
                            dataType: 'json',
                            type: 'post',
                            data: {'jmenoPracovnika': jmenoPracovnika.val()},
                            success: function (r) {
                                if (r.hasOwnProperty('data')) {
                                    response(r.data);
                                }
                            }
                        });
                    },
                    select: function (e, ui) {
                        e.preventDefault();
                        var uzivatelId = $('#modal-uzivatelid');
                        if (ui.item === null) {
                            $(this).val('');
                            uzivatelId.val('');
                        } else {
                            uzivatelId.val(ui.item.id);
                            $(this).val(ui.item.label);
                            $(this).blur();
                        }
                    }
                });
            });
        },

        disableModalButton: function (button) {
            if (!button.length) {
                return;
            }
            button.prop('disabled', true).attr('disabled', true);
        },

        enableModalButton: function (button, elements) {

            if (!button.length || !elements.length) {
                return;
            }

            var disabled = false;
            $.each(elements, function (i, name) {
                var element = $('#modal-' + name);
                if (element.length) {
                    if (!element.val()) {
                        disabled = true;
                    }
                }
            });

            button.prop('disabled', disabled).attr('disabled', disabled);
        },

        modalUploadModifyButton: function () {

            // miniformulář příloh
            $(document).on('modal.miniform.item.add.build modal.miniform.item.add.error modal.miniform.item.edit.build modal.miniform.item.edit.error', function (e) {

                var isValid = false;
                $.each(['program', 'title', 'request', 'donation', 'title-template'], function (i, name) {
                    var element = $('#modal-' + name + '-attachment');
                    if (element.length) {
                        isValid = true;
                    }
                });

                if (false == isValid) {
                    return;
                }

                var primaryButton = $('#dialogButtons').find('.btn.btn-primary');
                if (!primaryButton.length) {
                    return;
                }

                var testElements = [];
                if(/edit/.test(e.namespace)) {
                    testElements = ['name', 'typprilohy'];
                } else {
                    Plugin_Common.disableModalButton(primaryButton);
                    testElements = ['file', 'name', 'typprilohy'];
                }

                $.each(['file', 'name', 'description', 'typprilohy'], function (i, name) {

                    var element = $('#modal-' + name);
                    if (!element.length) {
                        return true;
                    }

                    if (element.length) {
                        element.on('input change keydown click', function () {
                            Plugin_Common.enableModalButton(primaryButton, testElements);
                        });
                    }
                });
            });
        },

        replaceGridPagers: function () {

            var url = window.location.href;
            if(false == /verejnost/i.test(url)) {
                return;
            }

            $('td[id$="_pager_left"]').each(function(i, element) {
                $(element).replaceWith('<td id="' + $(element).attr('id') + '" align=\"left\"><\/td>');
            });
        },

        highlightOpenedTitles: function () {

            var url = window.location.href;
            if(false == /verejnost/i.test(url)) {
                return;
            }

            $('#DotacniTitulyOtevrene').on('jqGridGridComplete', function (e) {
                $(this).children('tbody').children("tr.ui-widget-content").addClass('kupk-highlight-success');
            });
        },

        /**
         * detect IE
         * returns version of IE or false, if browser is not Internet Explorer
         */
        detectIE: function() {
            var ua = window.navigator.userAgent;

            var msie = ua.indexOf('MSIE ');
            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
            }

            var trident = ua.indexOf('Trident/');
            if (trident > 0) {
                // IE 11 => return version number
                var rv = ua.indexOf('rv:');
                return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
            }

            var edge = ua.indexOf('Edge/');
            if (edge > 0) {
                // IE 12 => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
            }

            // other browser
            return false;
        }
    }
}

$(document)
    .ready(function () {
        Plugin_Common.init();
        Plugin_Common.initPracovniciAutocomplete();
    });
